<header class="container-fluid bs-stepper horizontal-wizard-example bg-white">
    <div class="row" [ngClass.sm]="'m-0'">
        <div class="col-12 bs-stepper-header" [ngClass.sm]="'px-2 justify-content-center'">
            <div [class]="classesMasterData" [ngClass.md]="'pr-1'" data-target="#account-details" [ngbTooltip]="'MASTERDATA' | translate">
                <i [routerLink]="classesMasterData.includes('done')  ? ['/onboarding/masterdata'] : []" class="fw-normal">
                    <div class="step-trigger">
                        <span class="bs-stepper-box"><i [data-feather]="'home'" class="font-medium-2"></i></span>
                        <div class="bs-stepper-label" [ngClass.sm]="'pr-1'">
                            <span class="bs-stepper-title">{{'MASTERDATA' | translate}}</span>
                            <span class="bs-stepper-subtitle">{{"INSERT.ADD_MASTERDATA"  | translate}}</span>
                        </div>
                    </div>
                </i>
            </div>
            <div class="line"><i [data-feather]="'chevron-right'" class="font-medium-2"></i></div>

            <div [class]="classesCertifications" [ngClass.md]="'px-1'" [ngbTooltip]="'EDUCATION_ONBOARDING' | translate">
                <i [routerLink]="classesMasterData.includes('done') && classesCertifications.includes('done')  ? ['/onboarding/education'] : []">
                    <div class="step-trigger">
                        <span class="bs-stepper-box"><i [data-feather]="'user'" class="font-medium-2"></i></span>
                        <div class="bs-stepper-label" [ngClass.sm]="'pr-1'">
                            <span class="bs-stepper-title">{{'EDUCATION_ONBOARDING' | translate}}</span>
                            <span class="bs-stepper-subtitle">{{"INSERT.ADD_EDUCATION" | translate}}</span>
                        </div>
                    </div>
                </i>
            </div>
            <div class="line"><i [data-feather]="'chevron-right'" class="font-medium-2"></i></div>

            <div [class]="classesExperiences" [ngClass.md]="'px-1'" data-target="#personal-info" [ngbTooltip]="'EXPERIENCES' | translate">
                <i [routerLink]="classesMasterData.includes('done') && classesCertifications.includes('done') && classesExperiences.includes('done')  ? ['/onboarding/experiences'] : []">
                    <div class="step-trigger">
                        <span class="bs-stepper-box"><i [data-feather]="'user'" class="font-medium-2"></i></span>
                        <div class="bs-stepper-label" [ngClass.sm]="'pr-1'">
                            <span class="bs-stepper-title">{{"EXPERIENCES" | translate}}</span>
                            <span class="bs-stepper-subtitle">{{"INSERT.ADD_EXPERIENCE"  | translate}}</span>
                        </div>
                    </div>
                </i>
            </div>
            <div class="line"><i [data-feather]="'chevron-right'" class="font-medium-2"></i></div>

            <div [class]="classesSkills" [ngClass.md]="'px-1'" data-target="#address" [ngbTooltip]="'SKILLS' | translate">
                <i [routerLink]="classesMasterData.includes('done') && classesCertifications.includes('done') && classesExperiences.includes('done') && classesSkills.includes('done') ? ['/onboarding/skills'] : []">
                    <div class="step-trigger">
                        <span class="bs-stepper-box"><i [data-feather]="'credit-card'" class="font-medium-2"></i></span>
                        <div class="bs-stepper-label" [ngClass.sm]="'pr-1'">
                            <span class="bs-stepper-title">{{'SKILLS' | translate}}</span>
                            <span class="bs-stepper-subtitle">{{"INSERT.ADD_SKILLS"  | translate}}</span>
                        </div>
                    </div>
                </i>
            </div>
            <div class="line"><i [data-feather]="'chevron-right'" class="font-medium-2"></i></div>

            <div [class]="classesLanguages" [ngClass.md]="'px-1'" data-target="#languages" [ngbTooltip]="'LANGUAGES' | translate">
                <i [routerLink]="classesMasterData.includes('done') && classesCertifications.includes('done')
                && classesExperiences.includes('done') && classesSkills.includes('done') && classesLanguages.includes('done')? ['/onboarding/languages'] : []">
                <div class="step-trigger">
                    <span class="bs-stepper-box"><i [data-feather]="'user'" class="font-medium-2"></i></span>
                    <div class="bs-stepper-label" [ngClass.sm]="'pr-1'">
                        <span class="bs-stepper-title">{{'LANGUAGES' | translate}}</span>
                        <span class="bs-stepper-subtitle">{{"INSERT.ADD_LANGUAGES" | translate}}</span>
                    </div>
                </div>
                </i>
            </div>

            <div class="line"><i [data-feather]="'chevron-right'" class="font-medium-2"></i></div>

            <div [class]="classesIban" [ngClass.md]="'px-1'" [ngbTooltip]="'IBAN' | translate">
                <i [routerLink]="classesMasterData.includes('done') && classesCertifications.includes('done')
                && classesExperiences.includes('done') && classesSkills.includes('done') && classesLanguages.includes('done') &&  classesIban.includes('done')? ['/onboarding/iban'] : []">
                <div class="step-trigger">
                    <span class="bs-stepper-box"><i [data-feather]="'credit-card'" class="font-medium-2"></i></span>
                    <div class="bs-stepper-label" [ngClass.sm]="'pr-1'">
                        <span class="bs-stepper-title">{{'IBAN' | translate}}</span>
                        <span class="bs-stepper-subtitle">{{"INSERT.ADD_IBAN" | translate}}</span>
                    </div>
                </div>
                </i>
            </div>

            <div class="line"><i [data-feather]="'chevron-right'" class="font-medium-2"></i></div>

            <div [class]="classedDocuments" [ngClass.md]="'pl-1'" [ngbTooltip]="'DOCUMENTS' | translate">
                <div class="step-trigger">
                    <span class="bs-stepper-box"><i [data-feather]="'file-text'" class="font-medium-2"></i></span>
                    <div class="bs-stepper-label" [ngClass.sm]="'pr-1'">
                        <span class="bs-stepper-title">{{'DOCUMENTS' | translate}}</span>
                        <span class="bs-stepper-subtitle">{{"INSERT.VIEW_DOCUMENT" | translate}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>

